module.exports = __webpack_public_path__ + "img/check-buy.08da10a3.png";